import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_org/org/chat/")({
  validateSearch: z.object({
    thread: z.string().optional(),
    archived: z.boolean().optional(),
    assignedToMe: z.boolean().optional(),
  }),
  beforeLoad: ({ context, search }) => {
    const organizationBusinessUnitId = (
      context as { savedOrgBusinessUnit?: { id?: string } }
    ).savedOrgBusinessUnit?.id;
    if (!organizationBusinessUnitId) {
      throw redirect({ to: "/org/providers" });
    }
    throw redirect({
      to: "/org/bu/$organizationBusinessUnitId/chat",
      params: { organizationBusinessUnitId },
      search,
    });
  },
});
